import React, { useEffect, useState } from "react";
import Layout from "../../../layout/Layout";
import { Box, Grid } from "@mui/material";
import Conversations from "../../../components/Messages/Conversations";
import MessagesBox from "../../../components/Messages/MessagesBox";
import { useDispatch, useSelector } from "react-redux";
import { getAllConversations } from "../../../redux/dispatchers/chats.dispatcher";

const Messages = () => {
  const dispatch = useDispatch();

  const { userData } = useSelector((state) => state.user);
  const { conversations } = useSelector((state) => state.chats);

  const [selectedChat, setSelectedChat] = useState(
    conversations?.[0]?.id || null
  );
  const [otherUserData, setOtherUserData] = useState(
    conversations?.[0]?.user || null
  );

  useEffect(() => {
    dispatch(getAllConversations(userData?.id));
  }, []);

  return (
    <Layout heading="Messages" noBtn>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
        }}
      >
        <Grid container spacing={2}>
          <Grid item size={{ xs: 12, sm: 4 }}>
            <Conversations
              selectedChat={selectedChat}
              setSelectedChat={setSelectedChat}
              setOtherUserData={setOtherUserData}
            />
          </Grid>
          <Grid item size={{ xs: 12, sm: 8 }}>
            <MessagesBox convoId={selectedChat} otherUserData={otherUserData} />
          </Grid>
        </Grid>
      </Box>
    </Layout>
  );
};

export default Messages;
